import './tjribs/style';
import FormStructure from './tjribs/form_structure';

export default FormStructure;